import { UsersListTooltip } from "@/components/common/userlist-tooltip";
import {
  mapInteractionsToUsersList,
  type NodeInteraction,
} from "@/components/common/userlist-tooltip.utils";
import { Badge, Button, Icon, RowCard } from "@elaniintc/goes-design-system";
import dayjs from "dayjs";
import { Link } from "react-router";

interface ConfirmAssociationCardProps {
  node: {
    id: string;
    status: string;
    started_at: string;
    node: {
      id?: string;
      display_name: string;
      type: string;
    };
    interactions?: NodeInteraction[];
  };
  index: number;
  procedureId: string;
}

const getBadge = (status: string) => {
  switch (status) {
    case "COMPLETED":
      return (
        <Badge size="xs" variant="success">
          Ingresado
          <Icon type="fas" name="check" className="text-success-quiet" />
        </Badge>
      );
    case "RUNNING":
    case "IN_PROCESS":
      return (
        <Badge size="xs" variant="info">
          En proceso
          <Icon type="fas" name="arrows-rotate" className="text-info-quiet" />
        </Badge>
      );
    case "PENDING":
    default:
      return (
        <Badge size="xs" variant="info">
          Pendiente
          <Icon type="fas" name="clock" className="text-info-quiet" />
        </Badge>
      );
  }
};

export const ConfirmAssociationCard = ({
  node,
  index,
  procedureId,
}: ConfirmAssociationCardProps) => {
  const badge = getBadge(node.status);
  const startedAt = node.started_at
    ? dayjs(node.started_at).format("DD/MM/YYYY HH:mm A")
    : "";

  const targetUrl = `/tramite/${procedureId}/confirmar-asociacion/${node.id}`;

  return (
    <Link to={targetUrl}>
      <RowCard
        key={node.id ?? index}
        title={
          <p className="font-normal text-base text-body-loud truncate leading-tight">
            {node.node?.display_name ?? "Confirmar asociación"}
          </p>
        }
        color={(() => {
          if (node.status === "COMPLETED") return "success";
          if (node.status === "RUNNING" || node.status === "IN_PROCESS")
            return "info";
          return "success";
        })()}
        icon={{
          name: "people-arrows",
          type: "fas",
          size: "lg",
        }}
        subtitle={startedAt ? `Iniciado ${startedAt}` : ""}
      >
        <RowCard.Right>
          {badge}

          {node.interactions && node.interactions.length > 0 && (
            <UsersListTooltip
              items={mapInteractionsToUsersList(node.interactions)}
            />
          )}

          <Button variant="ghost" size="xs" className="size-8">
            <Icon type="far" name="arrow-up-right" />
          </Button>
        </RowCard.Right>
      </RowCard>
    </Link>
  );
};
